import React from 'react';
import { bool, oneOf, shape, string } from 'prop-types';
import { Link } from 'react-router-dom';
import {resolveLinkProps} from "../../utils/resolveLinkProps";

const LinkUrl = ({ linkUrl, children, canonical_url, ...rest }) => {
  try {
    if (linkUrl === undefined) {
      return <></>;
    }
    const linkProps=resolveLinkProps(canonical_url)
    if (linkProps.href) {
        return <a href={linkProps.href} target="_blank" rel="noopener noreferrer">{children}</a>;
    } else {
      let processedLink=linkUrl
      try {
        processedLink = linkProps.to.endsWith('/') ? linkProps.to.slice(0, -1) : linkProps.to;
      }catch (e) {

        return <Link to={processedLink}>aaa{children}</Link>;
      }
      return <Link to={processedLink}>{children}</Link>;
    }

  } catch (e) {
    console.warn('Failed to resolve link', linkUrl.default, children, e);
  }
  return (
    <a href="#" {...rest}>
      {children}
    </a>
  );
};

export default LinkUrl;

LinkUrl.propTypes = {
  linkUrl: shape({
    default: string,
    setting: bool,
    type: oneOf(['default', 'category', 'product', 'page']),
  }),
};
